"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _vueChartjs = require("vue-chartjs");
var _vuePropertyDecorator = require("vue-property-decorator");
const {
  reactiveProp
} = _vueChartjs.mixins;
var _default = exports.default = {
  extends: _vueChartjs.Pie,
  mixins: [reactiveProp],
  props: ['options', 'validity'],
  mounted() {
    this.renderChart(this.chartData, this.validity);
  }
};